// 分类-各分类对应所有游戏列表
import { Link } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import SwiperCore, { Pagination } from "swiper";
import general from "../../../general";
import $ from "jquery";
import { useLockFn, useScroll, useMount, useUpdateEffect } from "ahooks";
import Dialog from "../../../lib/Dialog";
import Image from "../../../lib/Image";
import Banner from "./Banner";
import { splitStr } from "../../../utils/commonFunc";
import useActiveState from "../../../lib/useActiveState";
import { storageLocal } from "../../util/storage";

SwiperCore.use([Pagination]);

export default (props) => {
  const [app] = useActiveState("app");
  const [loading, setLoading] = useState();
  let [page, setPage] = useState(1);
  const [sort, setSort] = useState("def");
  let [games, setGames] = useState([]);
  const [more, setMore] = useState(true);
  const [isShow, setIsShow] = useState(false);
  let [banners, setBanners] = useState([]);
  const nextPageRequestedRef = useRef(0); // 已请求的下一页，防止触底时重复请求
  const load = useLockFn(async (parms = {}) => {
    if (loading) {
      return;
    }
    setLoading(true);
    Dialog.loading();
    let tmp = {
      categorize_id: props.tag,
      categorize_type: sort,
      page,
    };

    if (parms.page) {
      tmp.page = parms.page;
      if (parms.page === 1) nextPageRequestedRef.current = 0; // 刷新后允许再请求第 2 页
    }

    general.axios
      .post("/v3/base/appcategorize/getAppCategorizeData", tmp)
      .finally(() => {
        setLoading(false);
        Dialog.close();
      })
      .then((response) => {
        console.log("分类对应数据列表", response);
        let result = response.data.data;
        console.log(props, "--------------");
        let list = [];

        if (props.pagetype == 3) {
          // 设置banner
          banners = result.three?.banner;
          setBanners(result.three?.banner);
          list = result.three?.game;
        } else {
          list = result.two?.game;
        }
        console.log(games);

        games = parms.page === 1 || !parms.page ? list : [...games, ...list];
        setGames((games) =>
          parms.page === 1 || !parms.page ? list : [...games, ...list],
        );

        if (parms.page) {
          setPage(parms.page);
        }
        if (list && list.length > 0) {
          setMore(true);
        } else {
          setMore(false);
        }

        setIsShow(true);
      })
      .catch((error) => {
        Dialog.error(error.message);
      });
  });
  useMount(() => load());

  // 右侧列表在 .mains 内滚动，需监听该容器而非 window
  const scroll = useScroll(props.mainsRef);
  useEffect(() => {
    if (!props.active) return;
    const el = props.mainsRef?.current;
    if (scroll?.top < -80) {
      load({ page: 1 });
    }
    // 触底加载：仅当内容可滚动且用户滚到底部时加载，避免首屏不足一屏时立刻触发下一页
    if (el && more && !loading) {
      const nextPage = page + 1;
      const hasScroll = el.scrollHeight > el.clientHeight;
      const atBottom =
        hasScroll &&
        scroll?.top + el.clientHeight + 20 >= el.scrollHeight;
      // 同一页只请求一次，避免 effect 连续执行导致重复请求
      if (atBottom && nextPageRequestedRef.current !== nextPage) {
        nextPageRequestedRef.current = nextPage;
        load({ page: nextPage });
      }
    }
  }, [scroll, props.active, more, page, loading]);

  useUpdateEffect(() => {
    // 排序规则切换后，滚动到顶部或 banner 下方（右侧在 .mains 内滚动，不再滚 body）
    const scrollEl = document.querySelector(".game-index-type .mains");
    const duration = page * 300;
    if (scrollEl) {
      if (banners && banners.length > 0) {
        const topHeight = $("#classifyBanners")[0]?.clientHeight || 250;
        $(scrollEl).animate({ scrollTop: topHeight }, duration);
      } else {
        $(scrollEl).animate({ scrollTop: 0 }, duration);
      }
    }

    page = 1;
    setPage(1);
    if (props.active) {
      load({ page: 1 });
    }
  }, [sort]);

  return (
    // banner+游戏列表 / 纯游戏列表
    <div
      className={"game-type classify-banner" + (!props.tag ? " notag" : "")}
      style={{
        paddingBottom: storageLocal.has("kfUrl") ? "60px" : "20px",
      }}
    >
      {banners && banners.length > 0 && (
        <div className="banners" id="classifyBanners">
          <Banner banners={banners} type={props.pagetype} />
        </div>
      )}

      <div className="head">
        {[
          { id: "def", text: "默认排序" },
          { id: "new", text: "最新上架" },
          { id: "hot", text: "热门游戏" },
        ].map((item) => (
          <div
            key={item.id}
            className={"item " + (sort == item.id ? "active" : "")}
            onClick={() => setSort(item.id)}
          >
            {item.text}
          </div>
        ))}
      </div>

      {isShow ? (
        <>
          {games && games.length > 0 ? (
            <div className="body">
              {games.map((game, index) => (
                <Link
                  key={game.game_id}
                  to={"/game?id=" + game.game_id}
                  className="game-list-global-type"
                  style={{ padding: "10px 0 10px 10px" }}
                  onClick={() => {
                    document.body.style.overflow = "unset";
                  }}
                >
                  {index < 3 ? (
                    <img
                      src={`/resources/classify/${index}.png`}
                      alt=""
                      className="ranking-img"
                    />
                  ) : null}

                  <div className="game-list-global-type-left">
                    <div
                      className="icon"
                      style={{
                        width: "1.2rem",
                        height: "1.2rem",
                        marginRight: "10px",
                      }}
                    >
                      <Image src={game?.icon} />
                    </div>

                    <div className="data">
                      <div className="name">
                        <div
                          className="name-main"
                          style={{ fontSize: "0.28rem" }}
                        >
                          {game.game_name_main || game.game_name}
                        </div>

                        {game?.game_tags?.is_special_server_game == 2 && (
                          <div
                            className="dedicated-server"
                            style={{ fontSize: "0.18rem" }}
                          >
                            专服
                          </div>
                        )}
                      </div>

                      <div
                        className="desc"
                        style={{ fontSize: "0.2rem", marginBottom: "2px" }}
                      >
                        {splitStr(game.version)}

                        {game.game_name_branch && (
                          <>
                            <div className="circle"></div>
                            {game.game_name_branch}
                          </>
                        )}
                      </div>

                      <div className="info">
                        {game.benefits && (
                          <>
                            {game?.is_trial_game == 2 ? (
                              <>
                                <div className="play-tag">有奖试玩</div>
                                {game.benefits
                                  ?.split("+")
                                  .slice(0, 1)
                                  .map((item, index) => (
                                    <div key={index} className="tag">
                                      {item}
                                    </div>
                                  ))}
                              </>
                            ) : (
                              game.benefits
                                ?.split("+")
                                .slice(0, 2)
                                .map((item, index) => (
                                  <div key={index} className="tag">
                                    {item}
                                  </div>
                                ))
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  {game?.game_tags?.is_free_version == 2 ? (
                    <div
                      className="is-free-version"
                      style={{ marginRight: "23px" }}
                    >
                      <span>免费版</span>
                    </div>
                  ) : (
                    <>
                      {game.discount < 1 ? (
                        <div
                          className="is-free-version"
                          style={{ marginRight: "23px" }}
                        >
                          {parseFloat((game.discount * 10).toFixed(2))}折
                        </div>
                      ) : null}
                    </>
                  )}
                </Link>
              ))}
              {games && games.length > 0 && !more ? (
                <div className="view-end">别撩啦！已经到底啦~</div>
              ) : null}
            </div>
          ) : (
            <div
              style={{
                textAlign: "center",
                paddingTop: "30px",
              }}
            >
              <img style={{ width: "60%" }} src="/resources/empty.png" alt="" />
              <p>暂无数据~</p>
            </div>
          )}
        </>
      ) : null}
    </div>
  );
};
